module.exports = {"1":"Zeer slecht","2":"Slecht","3":"Gemiddeld","4":"Goed","5":"Uitstekend","1.5":"Zeer slecht","2.5":"Slecht","3.5":"Gemiddeld","4.5":"Uitstekend"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/nl-BE/star-ratings.json
// module id = 1320
// module chunks = 0